module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-72x72-b451f16269c122f34df112fb4d94d89d.png";